<template>
  <div class='breadcrumbs default-content'>
    <ul class='breadcrumbs__list'>
      <li v-for='(item, index) in items' :key='index' class='breadcrumbs__list-item'>
        <a v-if='item.url' :href='item.url' class='breadcrumbs__link'>{{item.name}}</a>
        <span v-else class='breadcrumbs__current'>{{item.name}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        default: [],
        type: Array
      }
    },
    data() {
      return {
        showMore: false,
        selected: [],
      };
    },
  };
</script>